<!-- eslint-disable -->
<script>
import { mapState, mapGetters } from 'vuex'
import Subscription from '../profile/subscription'
import SubscriptionCard from '@components/cards/subscription-card.vue'
import NewYearChallenge from './new-year-challenge.vue'
import SelectSubscription from './select-subscription'
import BreadCrumbs from '@components/breadcrumbs/breadcrumbs-wrapper.vue'

import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: ['skuId', 'planId', 'name'],
  components: {
    SelectSubscription,
    BreadCrumbs,
    Subscription,
    SubscriptionCard,
    NewYearChallenge
  },
  data () {
    return {
      step: 1,
      stripErrorMessage: {},
    }
  },
  mounted () {
    if(this.activeSubscription) {
      // Set active subscription as default and then let the user change it
      this.$store.commit('setSelectedOrder', { sku: this.activeChallenge.plans[0].id, plan: this.activeSubscription.plan.id })
    }
  },
  beforeDestroy() {
    this.$store.commit("setSelectedSubscription", {})
  },
  computed: {
    ...mapState(['subscriptions', 'couponData', 'user', 'selectedSubscription', 'selectedOrder']),
    ...mapGetters(['primaryColorRgb', 'activeChallenge', 'activeChallengePrice', 'activeSubscription', 'hasNativeSubscription', 'hasActiveNativeSubscription', 'isCurrentSubscriptionPlan', 'isSubscriptionPlanMatchingLegacy', 'isAnnualSubscriptionPlanSelected', 'isChallengeFreeForSelectedSubscription']),
    _ () {
      return _
    },
    price () {
      let priceObj = this.subscriptions[0].plans.find((plan) => {
        return plan.id === this.selectedSubscription.id
      })
      return priceObj ? priceObj.amount / 100 : 0
    },
    fullPrice () {
      let fullAmount = 0
      let interval = this.selectedSubscription.interval
      let interval_count = this.selectedSubscription.interval_count
      if(this.price && (this.selectedSubscription && !this.isCurrentSubscriptionPlan && !this.hasNativeSubscription && !this.isSubscriptionPlanMatchingLegacy)) {
        fullAmount += this.price
      } else if(this.hasNativeSubscription && this.hasActiveNativeSubscription) {
        let plan_type = this.user.profile.subscription_plan_type;
        if(interval == 'month' && interval_count == 1) {
          if (!plan_type?.includes('month')) {
            fullAmount += this.price;
          } 
        } else if(interval == 'year') {
          if (!plan_type?.includes('annual') || !plan_type?.includes('year') || !plan_type?.includes('anual')) {
            fullAmount += this.price;
          } 
        } else if(interval == 'month' && interval_count == 3) {
          if (!plan_type?.includes('quarter')) {
            fullAmount += this.price;
          } 
        } else {
          //New usecase
          console.error('interval map between native and stripe not accounted for')
        }
      }

      // Add the challenge price to total if no annual selected or no option to have free with annual subscription
      if(this.activeChallengePrice && !this.isChallengeFreeForSelectedSubscription) {
        fullAmount += (this.activeChallengePrice.unit_amount / 100)
      }

      if(!isEmpty(this.couponData)) {
        const amountOff = this.couponData.amount_off ? (this.couponData.amount_off / 100).toFixed(2) : (fullAmount * this.couponData.percent_off/100).toFixed(2)
        fullAmount -= amountOff;
      }

      return {
        int: parseInt(fullAmount.toFixed(2)),
        string: fullAmount.toFixed(2)
      }
    }
  },
  methods: {
    setSubscription (subscription) {
      this.$store.commit('setSelectedSubscription', subscription)
      const selectedOrder = cloneDeep(this.selectedOrder)
      if(this.activeSubscription && this.activeSubscription.plan && this.activeSubscription.plan.interval === subscription.interval) {
        selectedOrder.plan = ''
      }
      else {
        selectedOrder.plan = subscription.id
      }
      this.$store.commit('setSelectedOrder', selectedOrder)
    },
    setStripeError (val) {
      this.stripErrorMessage = val
    },
    next () {
      if(this.step + 1 === 3) {
        window.Leanplum.track('Checkout', { action: 'attempted_checkout', user_id: this.user?._id, price_id: this.selectedOrder?.plan, product_id: this.selectedOrder?.sku || ' '})
        this.$store.dispatch('startSession', { token: this.user.token, prices: [this.selectedOrder.plan, this.selectedOrder.sku] })
      }
      else {
        this.step++
      }
    },
    back () {
      if (this.hasNativeSubscription && this.hasActiveNativeSubscription && !this.activeChallengePrice.metadata.freeWithAnnual) {
        this.step = 1
      } else if (this.step > 1) {
        this.step--
      }
    }
  }
}
</script>

<template>
  <b-container>

      <div :class="['row header', { error: !isEmpty(stripErrorMessage) &&
        stripErrorMessage.code &&
        stripErrorMessage.code !== 'incomplete_number' &&
          stripErrorMessage.code !== 'incomplete_expiry' &&
          stripErrorMessage.code !== 'incomplete_cvc' }]">
      <div v-if="!isEmpty(stripErrorMessage) &&
          stripErrorMessage.code &&
          stripErrorMessage.code !== 'incomplete_number' &&
          stripErrorMessage.code !== 'incomplete_expiry' &&
          stripErrorMessage.code !== 'incomplete_cvc' "
        class="col-5 message">{{stripErrorMessage.message}}</div>
      <BreadCrumbs v-if="step > 2 && !(!isEmpty(stripErrorMessage) &&
          stripErrorMessage.code &&
          stripErrorMessage.code !== 'incomplete_number' &&
          stripErrorMessage.code !== 'incomplete_expiry' &&
          stripErrorMessage.code !== 'incomplete_cvc')" @back="back" :title="activeSubscription && !isAnnualSubscriptionPlanSelected ? 'challenge.purchase.step3.back' : 'challenge.purchase.step2.title.default'"/>
      <div class="col action"></div>
      <div @click="$bvModal.hide('modal-challenge-purchase')" class="col close">&times;</div>
    </div>
      <NewYearChallenge
        v-if="step === 1"
        @next="next"
        @back="back"
      />
      <SelectSubscription
        v-if="step === 2"
        :isAnnualSelected="isAnnualSubscriptionPlanSelected"
        :selectedSubscription="selectedSubscription"
        @set-subscription="setSubscription"
        :fullPrice="fullPrice.int"
        @next="next"
        @back="back"
      />
  </b-container>
</template>

<style lang="scss" scoped>

.container {
  padding: unset;
  .header {
      z-index: 2;
      background-color: unset;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      height: 70px;
      border-top-right-radius: 24px;
      border-top-left-radius: 24px;
      margin-right: unset;
      margin-left: unset;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 99;
      background-color: var(--BGColor);
      cursor: pointer;
      .breadcrumb-wrapper {
        align-self: flex-start;
        margin-left: -0.5rem;
        position: absolute;
        left: 2.3rem;
        top: 27px;
        ::v-deep img {
          margin-right: 0.5rem;
        }
        ::v-deep h5 {
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          font-size: 20px;
          line-height: 23px;
          color: #000000;
          opacity: 0.5;
        }
      }
      .close {
        color: black;
        opacity: 1;
        width: 1rem;
        max-width: fit-content;
        margin-bottom: 5px;
        margin-right: 1.1rem;
        text-shadow: unset;
      }
      .action {
        max-width: 35%;
        margin-right: 1rem;
        .button {
          background: #FFFFFF;
          color: #F15555;
          margin-bottom: unset;
          max-width: unset;
          font-style: normal;
          font-weight: bold;
          font-size: 1.1rem;
          padding: 0.75rem;
        }
      }
      .message {
        color: white;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 150%;
        margin-left: 2rem;
      }
      &.error {
        background: #F15555;
        .close {
          color: white;
        }
        .breadcrumb-wrapper {
          ::v-deep h5 {
            color: white;
            opacity: 1;
          }
          ::v-deep path {
            stroke: white;
          }
        }
      }
    }
}

.container {
  padding-left: unset !important;
  padding-right: unset !important;
  padding: 0 1rem;
}

@media screen and (max-width: 700px) {
  .container {
    .header {
      .breadcrumb-wrapper {
        ::v-deep h5 {
          font-size: 16px;
          line-height: 23px;
        }
      }
    }
  }
}
</style>
